import React, { useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import CustomTextField from "../../Components/Reusable/CustomTextField";

import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import SubmitButton from "../../Components/Reusable/Buttons";
import CustomTextArea from "../../Components/Reusable/CustomTextArea";
import Image from "../../Components/Reusable/Image";
import { SvgImages } from "../../Utils/LocalImages";
import ApiService from "../../Services/ApiService";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const [contactInfo, setContactInfo] = useState();

  const getSocialContactInfo = async () => {
    try {
      const response = await ApiService.getSocialContactInfo();
      setContactInfo(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  }

  useEffect(() => { getSocialContactInfo() }, [])

  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"Contact Us"}   breadCrumpPageTitle={"Contact Us"} />
      <div className="text-content-page-container d-flex flex-column align-items-center">
        <div className="contact-us-banner d-flex align-items-center gap-4 mx-3 container">
          <div className="d-flex flex-column gap-3 w-100">
            {/* <h2 className="Heading fw-600 white mb-0">We want to hear from You</h2> */}
            <p className="Sub-Heading fw-400 white mb-0">Enhance your child's academic performance from an early age with the Bharat SAT examination and the Pradnya Learn and Achieve Study App, Mock Test package.</p>
            <p className="Sub-Heading fw-400 white mb-0 mt-4" > Contact us to learn more and get started today!</p>
          </div>

          <ContactUsForm additionalClasses="contact-us-form-desktop" />
        </div>

        <ContactUsForm additionalClasses="contact-us-form-mobile my-3" isMobileView={true} />

        <div className="row g-4 w-100">
          <div className="col-md-6 col-lg-4">
            <div className="contact-us-info-cards d-flex px-3 py-4">
              <div className="contact-us-info-cards-image-background">
                <Image src={SvgImages.location} style={{ width: 30, aspectRatio: 1 }} />
              </div>
              <div className="w-100 d-flex flex-column ms-3">
                <h2 className="Sub-Heading fw-600 black mb-0">Address</h2>
                <Link to={`https://maps.google.com/?q=${encodeURIComponent(contactInfo?.location ?? "A301 UPTOWN AVENUE, Building NO.2, S.NO-743/2, Panvel, Raigad (MH)- 410206, Maharashtra.")}`} target="_blank" rel="noopener noreferrer">
                  <h3 className="Sub-Heading fw-500 black mb-0 mt-2 Responsiveaddress" style={{ overflowWrap: "anywhere" }}>{contactInfo?.location ?? "A301 UPTOWN AVENUE, Building NO.2, S.NO-743/2, Panvel, Raigad (MH)- 410206, Maharashtra."}</h3>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="contact-us-info-cards d-flex px-3 py-4">
              <div className="contact-us-info-cards-image-background">
                <Image src={SvgImages.email} style={{ width: 30, aspectRatio: 1 }} />
              </div>
              <div className="w-100 d-flex flex-column ms-3">
                <h2 className="Sub-Heading fw-600 black mb-0">Email</h2>
                <Link to={`mailto:${contactInfo?.email ?? "info@learnandachieve.in"}`}>
                  <h3 className="Sub-Heading fw-500 black mb-0 mt-2" style={{ overflowWrap: "anywhere" }}>{contactInfo?.email ?? "info@learnandachieve.in"}</h3>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div className="contact-us-info-cards d-flex px-3 py-4">
              <div className="contact-us-info-cards-image-background">
                <Image src={SvgImages.time} style={{ width: 30, aspectRatio: 1 }} />
              </div>
              <div className="w-100 d-flex flex-column ms-3">
                <h2 className="Sub-Heading fw-600 black mb-0">Time</h2>
                <h3 className="Sub-Heading fw-500 black mb-0 mt-2" style={{ overflowWrap: "anywhere" }}>{contactInfo?.day ?? "Sunday - Friday"}</h3>
                <h3 className="Sub-Heading fw-500 black mb-0 mt-1" style={{ overflowWrap: "anywhere" }}>{contactInfo?.time ?? "08:00 AM - 05:00 PM"}</h3>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div className="contact-us-info-cards d-flex px-3 py-4">
              <div className="contact-us-info-cards-image-background">
                <Image src={SvgImages.phone} style={{ width: 30, aspectRatio: 1 }} />
              </div>
              <div className="w-100 d-flex flex-column ms-3">
                <h2 className="Sub-Heading fw-600 black mb-0">Phone</h2>
                <Link to={`tel:${contactInfo?.phone ?? "883-0340425"}`}>
                  <h3 className="Sub-Heading fw-500 black mb-0 mt-2" style={{ overflowWrap: "anywhere" }}>{contactInfo?.phone ?? "883-0340425"}</h3>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div>
  );
};
export default ContactUs;

function ContactUsForm({ additionalClasses, isMobileView = false }) {
  const validationSchema = Yup.object().shape({
    name: validationRegex.required,
    email: validationRegex.email,
    subject: validationRegex.required,
    message: validationRegex.required
  });

  const [charCount, setCharCount] = useState(0);

  const updateCharCount = (count) => {
    setCharCount(count);
  };


  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema),
  });


  const onSubmit = async (data) => {
    try {
      await ApiService.submitContactUsApi(data);
      reset();
      toast.success("Query Submitted");
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <div className={`contact-us-form d-flex flex-column ${additionalClasses ? additionalClasses : ""}`}>
      <h2 className={`Small-Heading fw-600 mb-0 ${isMobileView ? "headingColor" : "black"}`}>Leave us a Message</h2>
      <form action="" className="d-flex flex-column gap-4 mt-4" onSubmit={handleSubmit(onSubmit)}>
        <CustomTextField
          labelTitle="Name"
          id="name"
          name="name"
          inputType={InputType.text}
          placeholder="Enter your name"
          showError={errors?.name}
          errorMessage={errors?.name?.message}
          register={register}
        />

        <CustomTextField
          labelTitle="Email ID"
          id="email"
          name="email"
          inputType={InputType.email}
          placeholder="Enter your email id"
          showError={errors?.email}
          errorMessage={errors?.email?.message}
          register={register}
        />

        <CustomTextField
          labelTitle="Subject"
          id="subject"
          name="subject"
          placeholder="Enter your subject"
          showError={errors?.subject}
          errorMessage={errors?.subject?.message}
          register={register}
        />

        <CustomTextArea
          labelTitle="Message"
          id="message"
          name="message"
          placeholder="Max limit 300 Characters"
          showError={errors?.message}
          errorMessage={errors?.message?.message}
          register={register}
          rows={4}
          onChange={(e) => updateCharCount(e.target.value.length)}
        />
        {/* {charCount > 0 && (
          <p className="Caption fw-500 position-absolute grey" style={{ bottom: "-15px", right: "0" }}>
            {300 - charCount} characters remaining
          </p>
        )} */}

        <div className={`d-flex ${isMobileView ? "justify-content-end" : "justify-content-center"}`}>
          <SubmitButton title={"Send Message"} onClick={() => {
            handleSubmit(onSubmit)
          }} />
        </div>
      </form>
    </div>
  );
}

